import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { SelectField } from 'shared/controls/select-field';
import { useBrandContactInfo } from 'shared/queries';
import { Brands } from 'shared/types';
export function BrandContactDropdown() {
  const { brand } = useParams<{ brand: Brands }>();
  const { contactInfo, isLoading } = useBrandContactInfo(brand);
  const {
    setValue,
    formState: { errors },
  } = useFormContext();

  useEffect(() => {
    if (contactInfo?.length === 1) {
      setValue('brandContact', contactInfo[0]);
    }
  }, [contactInfo, setValue]);

  return (
    <SelectField
      name='brandContact'
      label='Branch Selection'
      readOnly={true}
      options={contactInfo || []}
      loading={isLoading}
      getOptionLabel={contact => {
        return contact.name ? ` ${contact.name}` : '';
      }}
      getOptionSelected={(option, value) => {
        if (!option || !value) return true;
        return option.uniqueId === value.uniqueId;
      }}
      rules={{
        required: {
          value: true,
          message: 'Branch Selection is required.',
        },
      }}
      error={Boolean(errors?.brandContact)}
      helperText={errors?.brandContact?.message}
    />
  );
}
